import ReconnectingWebSocket from 'reconnecting-websocket';
import { useContext, useEffect, useRef, useState } from 'react';
import { createContext } from 'react';
import AuthContext from '../../../../../context/AuthContext';
import { WS_URL } from '../../../../../config';

export const dispatcher_dynamic_context = createContext();

export const DynamicDispatchProvider = ({ children }) => {
  const { authTokens } = useContext(AuthContext);
  const webSocket = useRef(null);

  const [allAboutVZU, setAllAboutVZU] = useState([]);
  const [daylyReport, setDaylyReport] = useState([]);
  const [reportLength, setReportLength] = useState({});

  useEffect(() => {
    if (!authTokens?.access) {
      return;
    }

    webSocket.current = new ReconnectingWebSocket(
      `${WS_URL}/ws/dispather_check/?token=${authTokens.access}`
    );

    const sendWebSocketData = (action) => {
      const requestData = {
        action,
        request_id: new Date().getTime(),
        data: authTokens.access,
      };

      webSocket.current.send(JSON.stringify(requestData));
    };

    const processDynamicData = (message) => {
      const safeMessage = Array.isArray(message) ? message : [];
      const finalArr = {};

      safeMessage.forEach((item) => {
        const dynamics = Array.isArray(item?.dynamics) ? item.dynamics : [];
        const chlorine = Array.isArray(item?.chlorine) ? item.chlorine : [];

        const pressureFlag = dynamics.some(
          (item1) => item1?.pressure !== undefined && item1?.pressure !== null
        );

        const waterLevelInReseruarFlag = dynamics.some(
          (item1) =>
            item1?.water_level_in_reseruar?.[0] !== undefined &&
            item1?.water_level_in_reseruar?.[0] !== null
        );

        const maxChlorineFlag = chlorine.some(
          (item1) => item1?.max_chlorine !== undefined && item1?.max_chlorine !== null
        );

        let arr = [
          pressureFlag ? 'pressure' : null,
          waterLevelInReseruarFlag ? 'water_level_in_reseruar' : null,
          maxChlorineFlag ? 'max_chlorine' : null,
        ].filter(Boolean);

        // Если ВЗУ за сутки ничего не передал — все равно показываем его в таблице
        if (arr.length === 0) {
          arr = ['pressure', 'water_level_in_reseruar'];
        }

        const normArr = arr.map((fieldName) => {
          if (fieldName === 'pressure') return 'Д';
          if (fieldName === 'water_level_in_reseruar') return 'Ур';
          if (fieldName === 'max_chlorine') return 'Хл';
          return '';
        });

        finalArr[item.vzu_name] = [arr.length, arr, normArr];
      });

      setReportLength(finalArr);
      setDaylyReport(safeMessage);
    };

    const handleWebSocketMessage = (e) => {
      try {
        const data = JSON.parse(e.data);

        if (
          data.act === 'connect' ||
          data.act === 'well_activity' ||
          data.act === 'pump_activity'
        ) {
          setAllAboutVZU(Array.isArray(data.message) ? data.message : []);
        } else if (
          data.act === 'dynamic_connect' ||
          data.act === 'dynamic_activity' ||
          data.act === 'chlorine_activity'
        ) {
          processDynamicData(data.message);
        }
      } catch (error) {
        console.error('Ошибка обработки сообщения WebSocket:', error);
      }
    };

    webSocket.current.onopen = () => {
      sendWebSocketData('on_connect');
      sendWebSocketData('on_dynamic_connect');
      sendWebSocketData('on_smena_connect');
      console.log('Подключение установлено');
    };

    webSocket.current.onmessage = handleWebSocketMessage;

    webSocket.current.onclose = (e) => {
      console.error('WebSocket closed unexpectedly:', e.reason);
    };

    webSocket.current.onerror = (err) => {
      console.error('WebSocket error:', err?.message || err);
    };

    return () => {
      if (webSocket.current) {
        webSocket.current.close();
      }
    };
  }, [authTokens?.access]);

  return (
    <dispatcher_dynamic_context.Provider
      value={{ allAboutVZU, daylyReport, reportLength }}
    >
      {children}
    </dispatcher_dynamic_context.Provider>
  );
};